<div class="main-report-create-comment col-md-12 col-lg-12 col-xl-12">
    <mat-accordion>
        <mat-expansion-panel #panel expanded="isDialog?true:false" hideToggle disabled>
            <mat-expansion-panel-header>
                <mat-panel-title class="request-info-title">
                    <span class="request-title">{{ textHeader | translate }}</span>
                    <span class="text-light" *ngIf="!isDialog && !viewOnly" (click)="showComment()">
                        <i class="fa fa-plus"></i>{{ 'addComment' | translate }}</span
                    >
                </mat-panel-title>
                <div class="header-actions">
                    <button class="close-btn flex-center" *ngIf="isDialog" (click)="cancelAdding()">
                        <span class="material-symbols-outlined close-dialog-btn flex-center"> close </span>
                    </button>
                    <mat-icon *ngIf="!isDialog && !pdfMode"
                        ><span class="material-symbols-outlined" (click)="panelOpenState(panel.expanded ? false : true)">
                            {{ panel.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                        </span></mat-icon
                    >
                </div>
            </mat-expansion-panel-header>
            <section *ngIf="commentsAttachment?.length && commentType === 'commentTypeStakeholder' && !pdfMode">
                <mat-form-field class="w-100 my-2" appearance="fill">
                    <div class="d-flex search-filter-btn">
                        <input #searchInput matInput (input)="onSearch($event)" placeholder="{{ 'search' | translate }}" />
                        <span class="material-symbols-outlined">search</span>
                    </div>
                </mat-form-field>
            </section>

            <section *ngIf="showListComments && !isLoader" class="section-comment" [ngClass]="{ 'pdf-mode-class': pdfMode }">
                <div class="container-item" *ngFor="let singleCommentAttachment of filteredCommentsAttachment; let i = index">
                    <div class="search-results-item">
                        <div class="image-container comment-user">
                            <img onerror="this.src='assets/images/user2.jpg'" class="img-profile" src="{{ singleCommentAttachment?.creator?.image }}" alt="" />
                            <div class="col">
                                <div class="">
                                    <div class="">
                                        <div class="disFlex commnetDate">
                                            <div>
                                                <p class="name bold">
                                                    <span> {{ singleCommentAttachment.creator?.name }}</span>
                                                </p>
                                            </div>
                                            <div>
                                                <p class="colorSize">{{ singleCommentAttachment?.createdAt | dateFormat: 'd MMM y - h:mm a' | async }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="disFlex commnetDate">
                                        <p class="name colorSize">{{ singleCommentAttachment.creator?.email }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex" *ngIf="!pdfMode && !isReportDevice">
                        <a class="text-pink" (click)="showMore(i)"
                            >{{ activeIndex === i ? ('hideComment' | translate) : ('showComment' | translate) }}
                            <mat-icon
                                ><span class="material-symbols-outlined">
                                    {{ activeIndex === i ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                                </span></mat-icon
                            >
                        </a>
                    </div>
                    <div *ngIf="activeIndex === i || pdfMode || isReportDevice" class="py-2">
                        <div class="fieldset" [innerHTML]="singleCommentAttachment?.body" style="white-space: pre-line"></div>
                        <div class="attached-files-container" *ngIf="singleCommentAttachment?.attachments?.length > 0">
                            <span class="input-label">{{ 'attachedFiles' | translate }}</span>
                            <app-attachments-list
                                [attachmentList]="singleCommentAttachment?.attachments"
                                [commentId]="singleCommentAttachment?.id"
                                [reportId]="reportId"
                                [action]="downloadAttachment"
                                [moduleName]="'report'"
                            ></app-attachments-list>
                        </div>
                    </div>
                </div>
            </section>
            <app-no-data [show]="!showListComments && !isLoader"></app-no-data>
            <app-loader *ngIf="isLoader"></app-loader>
            <div #addSection>
                <section class="div-padding" *ngIf="showAddComment || (isDialog && isAdding)">
                    <div class="inputName col-12 mb-3" tabindex="-1" id="add-section">
                        <div class="">
                            <label class="input-label">{{ 'comment' | translate }}</label>
                        </div>

                        <div [formGroup]="commentForm">
                            <textarea
                                #textarea
                                class="input-content input disabled pointerHover"
                                formControlName="{{ inputFormControl }}"
                                [(ngModel)]="textComment"
                                autosize
                                [minRows]="6"
                                [maxRows]="10"
                                [maxlength]="maxLength"
                                class="input-content input"
                            ></textarea>
                            <mat-hint class=""> {{ maxLength }}/{{ textarea.value.length }}</mat-hint>
                        </div>
                    </div>
                    <mat-hint *ngIf="hasRequiredError('inputFormControl')">{{ 'ticketingModule.fieldRequired' | translate }}</mat-hint>

                    <app-add-attachments
                        (passAttachmentList)="storeAttachmentList($event)"
                        [onlyUploadImages]="false"
                        [uploadAttachmentRequestType]="uploadAttachmentRequestType"
                        [isDisable]="isDisableAttachment"
                        [reportId]="reportId"
                        [userAttachment]="userAttachment"
                        [isRemoveAttachment]="isRemoveAttachment"
                    >
                    </app-add-attachments>
                </section>
            </div>
            <div class="py-1 col-lg-12 pt-2 div-padding" *ngIf="showAddComment || (isDialog && isAdding)">
                <div class="d-flex w-100 justify-content-start">
                    <div class="col-sm-7">
                        <button mat-button class="btn btn-coral" (click)="send()" [disabled]="disableBtn">
                            <span>{{ 'send' | translate }}</span>
                        </button>
                        <button (click)="cancelAdding()" mat-button class="cancel-btn mx-2">
                            {{ 'cancel' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
